import { FC } from 'react';

import { ArticleAuthor } from '@/types/article-author';

import { LazyLoadImage } from '../lazy-load-image';
import styles from './article-author-info.module.scss';

interface Props {
    articleAuthor?: ArticleAuthor;
}

const ArticleAuthorInfo: FC<Props> = (props) => {
    const { articleAuthor } = props;

    if (!articleAuthor) return null;

    return (
        <div className={styles.container}>
            <div className={styles.avatarContainer}>
                {articleAuthor.leadImage ? <LazyLoadImage className={styles.avatar} imageUrl={articleAuthor.leadImage} objectFit="cover" /> : null}
            </div>
            <div className={styles.name}>{articleAuthor.name}</div>
            <div className={styles.bio}>{articleAuthor.bio}</div>
        </div>
    );
};

export default ArticleAuthorInfo;
